export default function () {
  // ScrollMagic Scene [Array]
  var scrollMagicScenes = [];

  /**
   * ScrollMagicのシーンの高さを再計算する関数を格納する変数。
   * 後のSceneインスタンス化後に関数を格納している。
   * 使うときは「 refleshScrollMagicScenes();」の１行を実行する。
   * スライダープログラムやウインドウ幅変更など、Webページの高さが動的に変化したあとに実行させておく。
   */
  var refleshScrollMagicScenes;

  /**
   * 最後のリサイズイベントからの経過時間。
   * 連続で実行されないようにするため。
   */
  let scrollMagicLastResizeEventNow = 0;

  /**
   * スクロールアニメーションの管理
   * ScrollMagicで対応
   */
  (function ($) {
    // Scroll Magic。主にスクロール時のフェードインアニメーションで使用
    // init controller
    var controller = new ScrollMagic.Controller();

    // すべての[data-scroll]属性が付いている要素が見えたらクラスを付与
    // 参考: https://scrollmagic.io/examples/basic/reveal_on_scroll.html
    $('[data-scroll]').each(function () {
      var attrClass = $(this).attr('class');

      // クラス名で処理を変更するために値を取得
      var attrId = $(this).attr('id');

      // トリガーとなるブラウザ上部からの距離（0.9 = 90%）
      var triggerHookValue = .3;

      // メインビジュアルの場合
      if ('main-visual' === attrId) {
        triggerHookValue = 0;
      }

      // トリガーが終了となる要素の上部からの距離
      // 要素の高さを指定することで、要素が見えている間は常にenter状態になる
      var durationValue = $(this).innerHeight();
      // var durationValue = $(this).outerHeight();

      // トリガーとなる要素の上部からの距離
      var offsetValue = 0;

      /**
       * SERVICEの設計図セクションで、設計図が表示されている期間を長くする
       */
      if ('service-second-img' === attrId) {
        // 開始位置を早めにする
        triggerHookValue = .75;

        // 終了位置を少し遅めにする
        durationValue += durationValue / 2;
      }

      // ScrollMagic用のシーンを生成
      var scene = new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: triggerHookValue,
        duration: durationValue,
        offset: offsetValue,
        reverse: true
      })
        .on('enter', function (e) {
          // 要素表示時
          $(e.target.triggerElement()).addClass('js-is-inview');

          if (typeof e.target.triggerElement().dataset.bgClass !== 'undefined') {
            var data = e.target.triggerElement().dataset.bgClass;
            $('#home-background').addClass(data);
          }

          if ('service-second-img' == e.target.triggerElement().id) {
            $('#home-background').addClass('is-service-second-img-enter');
            $('#home-background').removeClass('is-service-second-img-leave');
          }
        })
        .on('leave', function (e) {
          // 要素非表示時
          // console.log("Leave");
          $(e.target.triggerElement()).removeClass('js-is-inview');

          if (typeof e.target.triggerElement().dataset.bgClass !== 'undefined') {
            var data = e.target.triggerElement().dataset.bgClass;
            $('#home-background').removeClass(data);
          }

          if ('service-second-img' == e.target.triggerElement().id) {
            $('#home-background').removeClass('is-service-second-img-enter');
            $('#home-background').addClass('is-service-second-img-leave');
          }
        })
        // デバッグ時にコメントアウトを解除
        // .addIndicators({
        //   name: attrClass
        // })
        .addTo(controller);

      scrollMagicScenes.push(scene);
    });

    // ScrollMagicのシーンの高さ再計算関数の実行用関数
    // シーンは各々別インスタンスなので、一括で関数を実行させる必要がある
    refleshScrollMagicScenes = function () {
      for (var i = 0; i < scrollMagicScenes.length; i++) {
        scrollMagicScenes[i].refresh();
      }
    };

    // 高さ再計算関数の実行
    refleshScrollMagicScenes();

    // 画像読み込み後に改めて高さの再計算を行う
    $(window).on('load', function () {
      refleshScrollMagicScenes();
    });

    // 4秒後に再計算
    setTimeout(function () {
      refleshScrollMagicScenes();
    }, 4000);

    // ウインドウリサイズ時に再計算
    $(window).on('resize', function () {
      // 最後の処理から200ミリ秒経過していないなら処理をしない
      if (performance.now() - scrollMagicLastResizeEventNow <= 200) return;

      // 高さ再計算
      refleshScrollMagicScenes();

      // 最後の処理をした時間を更新
      scrollMagicLastResizeEventNow = performance.now();
    });
  })(jQuery);
}
